import React from "react";
import {
  useDeleteEquipmentMutation,
  useFetchEquipmentsQuery,
} from "../../../../store";
import Box from "@mui/material/Box";
import ListHeader from "../../managementShared/ListHeader";
import { DataGrid } from "@mui/x-data-grid";
import { equipmentColumns } from "../utils/equipmentColumn";
import {
  CONFIRM_DIALOG,
  EQUIPMENT_DIALOG,
} from "../../../../store/slices/utils/dialogEnum";
import { useDispatch, useSelector } from "react-redux";
import { setEquipment } from "../../../../store/slices/applicationManagement/managementSlice";
import {
  closeDialog,
  openDialog,
} from "../../../../store/slices/dialog/dialogSlice";
import {
  openErrorToast,
  openSuccessToast,
} from "../../../../store/slices/toast/toastSlice";
import CustomConfirmDialog from "../../../../components/shared/CustomConfirmDialog";
import ManagementToolbar from "../../managementShared/ManagementToolbar";
import EquipmentForm from "./EquipmentForm";
import TextField from "@mui/material/TextField";

const EquipmentList = () => {
  const dispatch = useDispatch();
  const [searchText, setSearchText] = React.useState("");
  const [pagination, setPagination] = React.useState({
    pageSize: 5,
    page: 0,
  });
  const { data: equipments, isLoading: equipmentsLoading } =
    useFetchEquipmentsQuery({
      searchText: searchText,
      page: pagination.page === 0 ? 1 : pagination.page + 1,
      limit: pagination.pageSize,
    }, { refetchOnMountOrArgChange: true });
  const rowCountRef = React.useRef(equipments?.data.totalRowCount || 0);
  const rowCount = React.useMemo(() => {
    if (equipments?.data.totalRowCount !== undefined) {
      rowCountRef.current = equipments?.data.totalRowCount;
    }
    return rowCountRef.current;
  }, [equipments?.data.totalRowCount]);
  const [deleteEquipment, { isLoading: deleteLoading }] =
    useDeleteEquipmentMutation();
  const { equipment } = useSelector((state) => state.managementSlice);
  const { equipmentDialogOpen } = useSelector((state) => state.dialogSlice);

  const handleUpdate = (equipment) => {
    dispatch(setEquipment(equipment));
    dispatch(openDialog(EQUIPMENT_DIALOG));
  };
  const handleDelete = (equipment) => {
    dispatch(setEquipment(equipment));
    dispatch(openDialog(CONFIRM_DIALOG));
  };
  const closeDelete = () => {
    dispatch(setEquipment(null));
    dispatch(closeDialog(CONFIRM_DIALOG));
  };
  const postDelete = () => {
    deleteEquipment(equipment.id).then((res) => {
      if (res) {
        if (!res.data.isSuccess) {
          dispatch(openErrorToast(res.data.message));
        } else {
          dispatch(openSuccessToast("İşlem Tamamlandı"));
          closeDelete();
        }
      }
    });
  };
  return (
    <Box
      sx={{
        height: 500,
        width: "100%",
        marginTop: 20,
        flex: "flex",
        flexDirection: "column",
      }}
    >
      <ListHeader text="Ekipmanlar" />

      {equipment && (
        <CustomConfirmDialog
          handleConfirm={postDelete}
          title="Ekipman Silme Onayı"
          text="Bu ekipmanı silmek istediğinize emin misiniz?"
          isLoading={deleteLoading}
          handleClose={closeDelete}
        />
      )}

      {equipmentDialogOpen && <EquipmentForm />}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 2,
          width: "100%",
        }}
      >
        <TextField
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          placeholder="Marka-Model-Seri No-Servis Etiketine Göre Ara..."
          size="small"
          sx={{ width: 500 }}
        />
      </Box>
      <DataGrid
        rows={equipments?.data.equipments || []}
        loading={equipmentsLoading}
        rowCount={rowCount}
        disableColumnMenu
        columns={equipmentColumns(handleUpdate, handleDelete)}
        pageSizeOptions={[5, 10, 25, 50]}
        paginationMode="server"
        paginationModel={pagination}
        onPaginationModelChange={setPagination}
        disableRowSelectionOnClick
        slots={{
          toolbar: (props) => (
            <ManagementToolbar {...props} dialogType={EQUIPMENT_DIALOG} />
          ),
        }}
        showToolbar
      />
    </Box>
  );
};

export default EquipmentList;
